/**
 * @typedef {import('../../../../shared/BlogService/BlogPostExcerpt').default} Blogs
 * @typedef {import('./Response').default} Response
 */

import { blogService } from '../../../../service-container';
import { useEffect, useMemo, useState } from 'react';
import captureError from '../../../../utils/captureError';

/**
 * @param {boolean} [isGated]
 * @returns {Response}
 */
export default function useGetBlogs(isGated = false) {
	const [blogs, setBlogs] = useState(/** @type {Blogs[]} */ ([]));
	const [isError, setIsError] = useState(false);
	const [isGettingData, setIsGettingData] = useState(true);

	useEffect(() => {
		fetchData();
	}, [isGated]);

	/** @returns {Promise<void>} */
	async function fetchData() {
		setIsGettingData(true);

		try {
			const limit = isGated ? 3 : 12;
			const response = await blogService.getPostExcerpts('', 1, limit);

			setBlogs(response.posts);
		} catch (error) {
			captureError(error);
			setIsError(true);
		} finally {
			setIsGettingData(false);
		}
	}

	return useMemo(
		() => ({
			data: blogs,
			isError,
			isGettingData,
		}),
		[blogs, isError, isGettingData]
	);
}
